export const Reviewer = 'reviewer'
export const Editor = 'editor'
export const Manager = 'manager'
export const Administrator = 'administrator'